// api
export const API_ALERTS = '/ServiceNow/GetServiceNowIncidentsAlerts';

// redux
export const ALERTS_STORE = 'alerts';
export const ALERTS_STORE_LIST = 'alertsList';
